import { map } from 'rxjs/operators';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { of } from 'rxjs';
import { isNullOrEmpty } from '../../core/utils/common-functions';

@Pipe({
  name: 'imageUrl',
})
export class ImageUrlPipe implements PipeTransform {
  constructor(private http: HttpClient, private domSanitizer: DomSanitizer) {}

  transform(value: any, ...args: any[]): any {
    if (isNullOrEmpty(value)) {
      return of(value);
    }
    const observable = this.http
      .get(value, { observe: 'response', responseType: 'blob' })
      .pipe(
        map((response: HttpResponse<Blob>) =>
          URL.createObjectURL(response.body ? response.body : new Blob())
        ),
        map((unsafeBlobUrl: string) =>
          this.domSanitizer.bypassSecurityTrustUrl(unsafeBlobUrl)
        )
      );
    return observable;
  }
}
